import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import BottomInfo from '@/view/layout/bottomInfo/bottomInfo';
import { changePassword } from "@/api/user";
import { encrypt } from '@/utils/crypto';
import { store } from '@/store/index';
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ModifyPwd",
  components: {
    BottomInfo: BottomInfo
  },
  data: function data() {
    var _this = this;
    return {
      showPassword: false,
      pwdModify: {},
      rules: {
        password: [{
          required: true,
          message: this.$t('person-setting.check-error-empty-pwd'),
          trigger: "blur"
        }, {
          min: 6,
          message: this.$t('person-setting.check-error-length-pwd'),
          trigger: "blur"
        }],
        newPassword: [{
          required: true,
          message: this.$t('person-setting.check-error-empty-newpwd'),
          trigger: "blur"
        }, {
          min: 6,
          message: this.$t('person-setting.check-error-length-pwd'),
          trigger: "blur"
        }],
        confirmPassword: [{
          required: true,
          message: this.$t('person-setting.check-error-empty-cfpwd'),
          trigger: "blur"
        }, {
          min: 6,
          message: this.$t('person-setting.check-error-length-pwd'),
          trigger: "blur"
        }, {
          validator: function validator(rule, value, callback) {
            if (value !== _this.pwdModify.newPassword) {
              callback(new Error(_this.$t('person-setting.check-error-invalid-pwd')));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters("user", ["userInfo"])),
  methods: _objectSpread(_objectSpread({}, mapActions('user', ['LoginOut'])), {}, {
    onSubmit: function onSubmit() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.$refs.modifyPwdForm.validate(function (valid) {
                if (valid) {
                  changePassword({
                    username: _this2.userInfo.userName,
                    password: encrypt(_this2.pwdModify.password),
                    newPassword: encrypt(_this2.pwdModify.newPassword),
                    lastTeamId: _this2.userInfo.lastTeamId
                  }).then(function (res) {
                    if (res.code == 0) {
                      _this2.$message.success(_this2.$t('person-setting.msg-success'));
                      store.commit('user/needModifyPwd', false);
                      store.commit('user/LoginOut');
                    }
                    _this2.showPassword = false;
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  })
};